/* eslint-disable lingui/no-unlocalized-strings */

export const FLAGS = {
  // @deprecated удалить флаг
  staff: 'Просмотр в режиметехника'
} as const;

export type FLAG = keyof typeof FLAGS;

export const DEFAULT_STATES: Partial<Record<FLAG, boolean>> = {};
